import { render, staticRenderFns } from "./AdminHumanResources.vue?vue&type=template&id=18043b21"
import script from "./AdminHumanResources.vue?vue&type=script&lang=js"
export * from "./AdminHumanResources.vue?vue&type=script&lang=js"
import style0 from "./AdminHumanResources.vue?vue&type=style&index=0&id=18043b21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports